import { ref, watch } from "vue";
import api from "./api";
import state from "./state"

export default {
    setup() {
        const inputUrl = ref("")
        const inputErrorText = ref("")
        const isInputError = ref(false)
        const isButtonDisabled = ref(false)

        async function handleClick() {
            if (inputUrl.value.trim().length === 0) {
                isInputError.value = true
                inputErrorText.value = "Please add a link"
                return
            }

            isButtonDisabled.value = true

            const createShortenLinkResult = await api.createShortenLinks(inputUrl.value)
            if (createShortenLinkResult.isSuccessful === false) {
                inputUrl.value = ""
                isButtonDisabled.value = false
                return
            }
            state.value.links.push({shorten: createShortenLinkResult.shortenLink, original: inputUrl.value})
            inputUrl.value = ""

            isButtonDisabled.value = false
        }

        watch(inputUrl, () => {
            if (isInputError.value) {
                isInputError.value = false
            }
        })

        return {
          inputUrl,
          handleClick,
          isInputError,
          inputErrorText,
          isButtonDisabled,
        }
      }
}